export const alertEnum = {
  Danger: 'danger',
  Success: 'success',
  Information: 'information',
  OnlyMessage: 'only_message',
} as const
